import { inject } from '@angular/core';
import { CanActivateFn, createUrlTreeFromSnapshot } from '@angular/router';
import { SUPABASE } from '@sona/angular-auth-domain';

export const isAuthenticated = (commands?: any[]): CanActivateFn => {
    return async (route) => {
        const supabase = inject(SUPABASE);
        const isAuthenticated = (await supabase.auth.getSession()).data?.session?.access_token != null;

        if (!isAuthenticated) {
            return commands ? createUrlTreeFromSnapshot(route, commands) : false;
        }

        return true;
    };
};
